import React from 'react'
function Awards() {
    return ( 
        <div className="container mt-5 mb-5">
            <div className="row ">
                <div className="col-6">
                    <img src='media/images/largestBroker.svg' alt="Largest Broker Image" style={{width: "80%"}}/>
                </div>
                <div className="col-6 ">
                    <h1>Largest stock broker in india</h1>
                    <p>With over 6 million clients, we are the largest stock broker in India by active client base as per SEBI data.</p>
                    <ul>
                        <div className='row '>
                        <div className='col'> 
                            <li>
                                <p>
                                    Future and options
                                </p>
                            </li>
                            <li>
                                <p>
                                    Stocks & IPOs
                                </p>
                            </li>
                            <li>
                                <p>
                                    Commodity derivatives
                                </p>
                            </li>  
                        </div>
                        <div className='col'>
                            <li>
                                <p>
                                    Direct mutual funds
                                </p>
                            </li>
                            <li>
                                <p>
                                    Currency derivatives
                                </p>
                            </li>
                            <li>
                                <p>
                                    Bonds and Government securities
                                </p>
                            </li>
                            </div>
                            </div>
                    </ul>
                    <img src='media/images/pressLogos.png' alt='SEBI Logo' className='mt-3' style={{width:"80%"}}/>
                </div>
            </div>

        </div>
     );
}

export default Awards;